const SHARED_INCLUDED = ["Complimentary water", "Mobile charging", "Free 30 mins waiting"]

export const VEHICLE_OPTIONS = [
  {
    id: "first-class",
    name: "First Class",
    vehicle: "BMW 735i (2026)",
    image: "/fleet/first-class.png",
    passengers: 3,
    luggage: 2,
    hourlyRate: 312.5,
    pricing: {
      airport: 550,
      jeddahMakkah: 1200,
      makkahMadinah: 1500,
    },
    details: ["Premium sedan", "Ideal for VIP and executive travel", "Quiet luxury cabin"],
  },
  {
    id: "elite-suv",
    name: "Elite SUV",
    vehicle: "GMC Yukon XL (2025)",
    image: "/fleet/elite-suv.png",
    passengers: 7,
    luggage: 6,
    hourlyRate: 275,
    pricing: {
      airport: 500,
      jeddahMakkah: 500,
      makkahMadinah: 700,
    },
    details: ["Best for families", "Extra luggage capacity", "Comfortable premium SUV"],
  },
  {
    id: "business",
    name: "Business",
    vehicle: "Lexus ES / Ford Taurus",
    image: "/fleet/business.png",
    passengers: 3,
    luggage: 2,
    hourlyRate: 150,
    pricing: {
      airport: 350,
      jeddahMakkah: 350,
      makkahMadinah: 450,
    },
    details: ["Reliable executive ride", "Comfort for city and airport travel", "Strong value category"],
  },
  {
    id: "executive",
    name: "Executive",
    vehicle: "Mercedes Vito / Staria",
    image: "/fleet/executive.png",
    passengers: 6,
    luggage: 4,
    hourlyRate: 225,
    pricing: {
      airport: 450,
      jeddahMakkah: 500,
      makkahMadinah: 700,
    },
    details: ["Executive van comfort", "Perfect for small groups", "Premium and spacious"],
  },
  {
    id: "group",
    name: "Group",
    vehicle: "Toyota Hiace (2026)",
    image: "/fleet/group.png",
    passengers: 12,
    luggage: 8,
    hourlyRate: 187.5,
    pricing: {
      airport: 400,
      jeddahMakkah: 400,
      makkahMadinah: 600,
    },
    details: ["Best for large groups", "Strong luggage capacity", "Ideal for pilgrim and family travel"],
  },
  {
    id: "standard",
    name: "Standard",
    vehicle: "Toyota Camry",
    image: "/fleet/standard.png",
    passengers: 4,
    luggage: 2,
    hourlyRate: 100,
    pricing: {
      airport: 200,
      jeddahMakkah: 200,
      makkahMadinah: 300,
    },
    details: ["Comfortable everyday ride", "Affordable private transfer", "Good for city travel"],
  },
];

export function getPricedOptions({ tripType, mode, duration }) {
  return VEHICLE_OPTIONS.map((option) => {
    if (mode === "hourly") {
      const selectedHours = Number(duration || 4);
      const billableHours = Math.max(selectedHours, 4);

      return {
        ...option,
        details: [...option.details, ...SHARED_INCLUDED],
        price: option.hourlyRate * billableHours,
        pricingType: "fixed",
        billableHours,
        displayLabel: `SAR ${option.hourlyRate}/hr`,
      };
    }

    if (tripType === "general") {
      return {
        ...option,
        details: [...option.details, ...SHARED_INCLUDED],
        price: null,
        pricingType: "quote",
        billableHours: null,
        displayLabel: "Request quote",
      };
    }

    return {
      ...option,
      details: [...option.details, ...SHARED_INCLUDED],
      price: option.pricing[tripType] || null,
      pricingType: "fixed",
      billableHours: null,
      displayLabel: "Starting from",
    };
  });
}
